import { useQuery } from '@tanstack/react-query'

import { api } from '../../../services/api'
import { CityData } from '../../../types/interfaces'
import { queriesKeys } from '../queriesKeys'

export const useGetCityById = <T>(
  cityId: number,
  select?: (data: CityData) => T
) =>
  useQuery({
    enabled: !!cityId,
    queryFn: () => api.cities.getCityById(cityId),
    queryKey: queriesKeys.cities.getCityById(cityId),
    select,
  })
